import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import RetailDashboard from "./RetailDashboard/index";
// import SalesReport from "./SalesReports/index";
// import PaymentsReports from "./PaymentsReports/index";
// import InventoryReports from "./InventoryReports/index";
// import TaxReports from "./TaxReports/index"
import DynamicReports from "./DynamicReports/index";
import Registerclosures from "./RegisterClosures/index"
import StoreCreditReports from "./StoreCreditReports/index"
import GiftCardReports from "./GiftCardReports/index"
import InventoryMovementReports from './ProductInventoryMovements/index'

const ReportingParent = ({ match }) => (
  <Switch>
        <Route path={`${match.url}/retailDashboard`} component={RetailDashboard} />
        <Route path={`${match.url}/registerclosures`} component={Registerclosures} />
        <Route path={`${match.url}/gift_cards`} component={GiftCardReports} />
        <Route path={`${match.url}/store_credit`} component={StoreCreditReports} />
        <Route path={`${match.url}/salesreports`} component={DynamicReports}  key="sales-dynamic" />
        <Route path={`${match.url}/inventoryreports`} component={DynamicReports}   key="inventory-dynamic"/>
        <Route path={`${match.url}/paymentreports`} component={DynamicReports}  key="payment-dynamic" />
        <Route path={`${match.url}/taxreports`} component={DynamicReports}  key="tax-dynamic" />
        <Route path={`${match.url}/otherreports`} component={DynamicReports}  key="other-dynamic" />
        <Route path={`${match.url}/product-movements`} component={InventoryMovementReports} />
        <Route path={`${match.url}/product-movements`} render={props => <InventoryMovementReports{...props} />} />
  </Switch>
);

export default ReportingParent;
